export const EOL = "\n";
export const release = () => "";
